module.exports = __webpack_public_path__ + "static/media/FLOW.7457be6f.svg";